import React from 'react';
import Actions from 'groups/components/list/GroupsActions';
import { translate } from 'react-i18next';
import { formatMoney } from 'accounting-js';

const GroupsListRow = ({ company, subcompany, permissions, group, t, handleToggle }) => {
  return (
    <tr>
      <td>{group.key}</td>
      <td>{group.name}</td>
      <td>{group.description}</td>
      <td>{group.module}</td>
      <td className="text-center">{t(group.active ? 'common.yes' : 'common.no')}</td>
      <td className="text-center">
        <Actions
          company={company}
          group={group}
          handleToggle={handleToggle}
          permissions={permissions}
          subcompany={subcompany}
        />
      </td>
    </tr>
  );
};

export default translate()(GroupsListRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/components/list/GroupsListRow.js